import getTimeFormatted from './get-time-formatted';

export { getTimeFormatted };

export default getTimeFormatted;
